<template>
  <div ref="screenshotTarget" class="container-fluid page-title finance-mbl">
    <!-- <Labels :title="title" :main="desc" /> -->
    <div class="row starter-main">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header profit-sidebar">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="../../assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text-finance">
                <h5 class="title">Profitability</h5>
                <!-- <span class="subtitle">{{ updateProfit }}</span> -->
              </div>
              <div style="width: 20%" class="ctn-mbl m-r-10">
                <!-- <label>Holding/Suholding</label> -->
                <multiselect
                  class="custom_select"
                  v-model="instanceId"
                  placeholder="Select Instance"
                  label="label"
                  track-by="value"
                  select-label=""
                  :options="dataInstance"
                  :multiple="false"
                  :allow-empty="false"
                  deselect-label="Selected"
                ></multiselect>
              </div>
              <span @click="profit" class="text-detail"
                >P&L DETAILS <i class="fa fa-angle-right"></i
              ></span>
            </div>
            <!-- <div class="card-header-right container-profit">
            </div> -->
          </div>
          <!-- <div class="bg-label">
            <div class="header-top">
              <h6 class="m-0 text-alert">
                <img src="../../assets/images/svg-img/alert-finance.svg" />
                EBITDA margin is decreasing yoy due to increasing BPP and
                foreign exchange loss"
              </h6>
              <div class="card-header-right-icon">
                <DropDown1 />
              </div>
            </div>align-items: center;
          </div> -->
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="">
                  <div
                    v-for="(item, id) in leftChart"
                    :key="id"
                    style="cursor: pointer"
                    :class="{ clicked: item.clicked }"
                    class="card card_white_finance"
                    @click="detailItem(item)"
                  >
                    <div
                      style="display: flex; justify-content: space-between"
                      class="sub_title_2"
                    >
                      <span>{{ item.metricName }} {{ item.currency }}</span
                      ><span style="color: #7a7a7a; font-size: smaller"
                        >Grafik Trend</span
                      >
                    </div>
                    <div
                      style="
                        height: 55px;
                        display: flex;
                        justify-content: space-between;
                      "
                    >
                      <div
                        :style="isZoom ? 'zoom: 0.8;' : ''"
                        style="justify-content: space-between"
                        class="d-flex align-items-center"
                      >
                        <div class="data_text">
                          {{ convertCurrency(item.value) }} {{ item.unit }}
                        </div>
                        <div
                          style="flex: 1; text-align: right"
                          class="d-flex ms-2 data_detil"
                        >
                          <div
                            @mouseenter="showTooltipArc"
                            @mouseleave="hideTooltipArc"
                            v-if="item.achievement !== null"
                            class="d-inline-flex align-items-center me-2 tooltip-container"
                            :class="
                              item.achievementStatus === 'DOWN'
                                ? 'badge_red'
                                : 'badge_green'
                            "
                          >
                            <div v-if="visibleArc" class="tooltip-content">
                              <span>Achievement</span>
                            </div>
                            <IconSvg
                              :color="
                                item.achievementStatus === 'DOWN'
                                  ? 'red'
                                  : 'green'
                              "
                              :type="
                                item.achievementStatus === 'DOWN'
                                  ? 'arrow_down'
                                  : 'arrow_up'
                              "
                            />
                            <div
                              class="data_detil"
                              :style="
                                item.achievementStatus === 'DOWN'
                                  ? 'color: red'
                                  : 'color:green'
                              "
                            >
                              {{ item.achievement }}
                            </div>
                          </div>
                          <div
                            @mouseenter="showTooltip"
                            @mouseleave="hideTooltip"
                            v-if="item.trendStatus !== null"
                            class="d-inline-flex align-items-center tooltip-container"
                            :class="
                              item.trendStatus === 'DOWN'
                                ? 'badge_red'
                                : 'badge_green'
                            "
                          >
                            <div
                              style="left: 55px !important"
                              v-if="visible"
                              class="tooltip-content"
                            >
                              <span>Trend</span>
                            </div>
                            <IconSvg
                              :color="
                                item.trendStatus === 'DOWN' ? 'red' : 'green'
                              "
                              :type="
                                item.trendStatus === 'DOWN'
                                  ? 'chart_down'
                                  : 'chart_up'
                              "
                            />
                            <div
                              class="data_detil"
                              :style="
                                item.trendStatus === 'DOWN'
                                  ? 'color: red'
                                  : 'color:green'
                              "
                            >
                              {{ item.trend }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="place-self: center" class="">
                        <!-- <label>Grafik Trend</label> -->
                        <!-- <apexchart
                          ref="realtimeChart"
                          type="line"
                          :options="options4"
                          :series="item.datas"
                        ></apexchart> -->
                        <Line
                          style="width: 120px; height: 50px"
                          :data="formatingData(item.datas)"
                          :options="chartOptions"
                        />
                      </div>
                    </div>
                    <div
                      v-if="item.metricId !== 'REVENUE'"
                      style="color: #7a7a7a; font-size: small"
                    >
                      {{ Number(item.ofToRevenue).toFixed(2) }}% of Revenue
                    </div>
                    <div class="d-inline-flex align-items-center me-2">
                      <div style="color: #7a7a7a; font-size: small">
                        Period: {{ convertToMMMYYYY(item.month, item.year) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div>
                  <div class="profit-sidebar prod-mobile header-right-chart">
                    <div style="width: 40%" class="container-header">
                      <div class="text">
                        <h4 class="title-chart-right">
                          {{ titleProfit }} ({{ unitProfit }})
                        </h4>
                      </div>
                    </div>
                    <div class="prod-mobile card-header-right">
                      <div
                        style="display: flex"
                        class="prod-mobile text-center"
                      >
                        <div>
                          <label style="color: #999999">Period</label><br />
                          <button
                            @click="monthly"
                            class="border-period-left btn btn-square btn-small btn-disable"
                            :class="{ 'btn-info color-active': !isActiveMonth }"
                            type="button"
                          >
                            Month
                          </button>
                          <button
                            @click="monthly"
                            :class="{ 'btn-info color-active': isActiveMonth }"
                            class="border-period-right btn btn-square btn-disable btn-small m-r-10"
                            type="button"
                          >
                            Year
                          </button>
                        </div>
                        <div v-if="isYear">
                          <label style="color: #999999"
                            >Non-Cumulative/Cumulative</label
                          ><br />
                          <button
                            @click="cumulative"
                            class="border-period-left btn btn-square btn-disable btn-small"
                            :class="{
                              'btn-info color-active': !isActiveCumulative,
                            }"
                            type="button"
                          >
                            Non-Cumulative
                          </button>
                          <button
                            @click="cumulative"
                            :class="{
                              'btn-info color-active': isActiveCumulative,
                            }"
                            class="border-period-right btn btn-square btn-disable m-r-10 btn-small"
                            type="button"
                          >
                            Cumulative
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="m-t-25 profit-sidebar"
                    style="justify-content: space-between; display: flex"
                  >
                    <div>
                      <!-- <label>Holding/Subholding</label>
                      <multiselect
                        v-model="instanceId"
                        placeholder="Select Instance"
                        label="label"
                        track-by="value"
                        :select-label="false"
                        :options="dataInstance"
                        :multiple="false"
                        :allow-empty="false"
                        deselect-label="Selected"
                        :taggable="false"
                      ></multiselect> -->
                    </div>
                    <div class="m-r-15 m-t-20">
                      <div class="d-flex flex-row-reverse align-items-center">
                        <!-- <span style="color: red; font-weight: bold"
                          >......</span
                        >
                        <div>
                          <span style="color: red; font-weight: bold"
                            >......</span
                          >
                        </div> -->
                        <div class="legend-item">
                          <span class="custom_checkbox_texts">Target</span>
                          <div class="legend-symbol line-circle">
                            <div class="line"></div>
                            <div class="circle"></div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="(item, id) in dataCheckbox"
                        :key="id"
                        class="d-flex flex-row-reverse align-items-center"
                      >
                        <div>
                          <input
                            class="form-check-input custom_checkbox_revenue"
                            :style="{
                              backgroundColor: item.color,
                              borderColor: item.color,
                            }"
                            type="checkbox"
                            :value="item.id"
                            v-model="isCheckedProfit"
                          />
                        </div>
                        <div class="custom_checkbox_texts">{{ item.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body m-t-25 thermal-mobile">
                  <apexchart
                    height="1050"
                    width="100%"
                    type="line"
                    :options="options3"
                    :series="series3"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-header profit-sidebar">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="../../assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text-finance">
                <h5 class="title">Cash Management</h5>
                <!-- <span class="subtitle">Last Updated: {{ lastUpdateCash }}</span> -->
              </div>
              <div class="container-cash">
                <div class="gm-mobile m-r-20" style="width: 45%">
                  <multiselect
                    v-model="instanceIdCash"
                    placeholder="Select Instance"
                    label="label"
                    track-by="value"
                    select-label=""
                    :options="dataInstance"
                    :multiple="false"
                    :taggable="false"
                    :allow-empty="false"
                    deselect-label="Selected"
                  ></multiselect>
                </div>
                <span @click="detailCash" class="text-detail"
                  >CASH BALANCE DETAILS <i class="fa fa-angle-right"></i
                ></span>
              </div>
            </div>
          </div>
          <!-- <div class="bg-label">
            <div class="header-top">
              <h6 class="m-0 text-alert">
                <img src="../../assets/images/svg-img/alert-finance.svg" />
                Overall healthy financial indicators, EBITDA is below RKAP
                target.
              </h6>
              <div class="card-header-right-icon">
                <DropDown1 />
              </div>
            </div>
          </div> -->
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 profit-sidebar">
                <div class="container-cash-cart prod-mobile">
                  <div
                    v-for="(item, id) in dataProfit"
                    :key="id"
                    style="padding: 3%"
                    class="item gm-mobile card card_white_cash"
                    :class="id === 0 || id === 1 ? 'margin-card-cash' : ''"
                  >
                    <div class="sub_title_2">
                      {{ item.metricName }}
                    </div>
                    <div
                      style="justify-content: space-between"
                      class="d-flex align-items-center"
                    >
                      <div class="data_text_cash">
                        {{ convertCurrency(item.value) }} {{ item.unit }}
                      </div>
                      <div
                        style="flex: 1; text-align: right"
                        class="d-flex ms-2"
                      >
                        <div
                          @mouseenter="showTooltipArc"
                          @mouseleave="hideTooltipArc"
                          class="d-inline-flex align-items-center tooltip-container"
                          :class="
                            item.achievementStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <div v-if="visibleArc" class="tooltip-content">
                            <span>Achievement</span>
                          </div>
                          <IconSvg
                            :color="
                              item.achievementStatus === 'DOWN'
                                ? 'red'
                                : 'green'
                            "
                            :type="
                              item.achievementStatus === 'DOWN'
                                ? 'arrow_down'
                                : 'arrow_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.achievementStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{
                              item.achievement !== null ? item.achievement : "-"
                            }}
                          </div>
                        </div>
                        <div
                          @mouseenter="showTooltip"
                          @mouseleave="hideTooltip"
                          class="d-inline-flex align-items-center me-2 tooltip-container"
                          :class="
                            item.trendStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <div
                            style="left: 60px !important"
                            v-if="visible"
                            class="tooltip-content"
                          >
                            <span>Trend</span>
                          </div>
                          <IconSvg
                            :color="
                              item.trendStatus === 'DOWN' ? 'red' : 'green'
                            "
                            :type="
                              item.trendStatus === 'DOWN'
                                ? 'chart_down'
                                : 'chart_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.trendStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.trend !== null ? item.trend : "-" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="color: #7a7a7a; font-size: small">
                      {{ item.description }}
                    </div>
                    <div
                      @mouseenter="showTooltipDesc"
                      @mouseleave="hideTooltipDesc"
                      v-if="item.metricId === 'POTENTIAL_CASH'"
                      class="tooltip-container"
                    >
                      <div class="version-desc">
                        <i
                          v-if="item.versionDescription !== null"
                          class="fa fa-info-circle"
                          style="margin-right: 6px; color: #007bff"
                        ></i
                        >{{ item.versionDescription }}
                      </div>
                      <div v-if="visibleDesc" class="tooltip-content">
                        <span>{{ item.versionDescription }}</span>
                      </div>
                    </div>
                    <!-- <div
                      v-if="item.metricId === 'CASH_MONTHLY_BURN_RATE'"
                      style="color: #7a7a7a; font-size: small"
                    >
                      Excluding compensation
                    </div> -->
                    <div class="d-inline-flex align-items-center me-2">
                      <div
                        v-if="
                          item.metricId === 'POTENTIAL_CASH' ||
                          item.metricId === 'CASH_MONTHLY_BURN_RATE' ||
                          item.metricId === 'DSCR'
                        "
                        style="color: #7a7a7a; font-size: small"
                      >
                        {{
                          item.metricId === "CASH_MONTHLY_BURN_RATE"
                            ? `Realisasi ${convertToMMMYYYY(
                                item.month,
                                item.year
                              )}`
                            : `Forecast ${item.year}`
                        }}
                      </div>
                      <div v-else style="color: #7a7a7a; font-size: small">
                        Period:
                        {{
                          item.metricId === "CASH_BALANCE"
                            ? convertToDDMMMYYYY(
                                item.day,
                                item.month,
                                item.year
                              )
                            : convertToMMMYYYY(item.month, item.year)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="header-right-chart profit-sidebar">
                  <h6 class="title-chart-right">
                    DAILY CASH BALANCE TREND (IDR)<br />
                    <!-- <span style="color: #7a7a7a; font-size: small"
                      >tanpa Majapahit Holding BV</span
                    > -->
                  </h6>
                  <div class="container-header">
                    <div class="text">
                      <!-- <label>Holding/Subholding</label>
                      <multiselect
                        v-model="instanceIdCash"
                        :select-label="false"
                        placeholder="Select Instance"
                        label="label"
                        track-by="value"
                        :options="dataInstance"
                        :multiple="false"
                        :taggable="false"
                      ></multiselect> -->
                      <!-- <select
                        v-model="instanceIdCash"
                        class="custom-dropdown form-select"
                      >
                        <option
                          v-for="(option, key) in dataInstance"
                          :key="key"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select> -->
                    </div>
                  </div>
                  <div class="card-header-right">
                    <div class="text-end">
                      <div>
                        <div
                          v-for="(item, id) in dataCheckboxCash"
                          :key="id"
                          class="d-flex flex-row-reverse align-items-center"
                        >
                          <div
                            v-if="
                              item.type !== 'line' &&
                              item.id !== 'TOTAL' &&
                              item.id !== 'HOLDING' &&
                              item.id !== 'SUB_HOLDING'
                            "
                          >
                            <input
                              class="form-check-input custom_checkbox_revenue"
                              :style="{
                                backgroundColor: item.color,
                                borderColor: item.color,
                              }"
                              type="checkbox"
                              :value="item.id"
                              v-model="isCheckedCash"
                            />
                          </div>
                          <div
                            v-if="
                              item.type !== 'line' &&
                              item.id !== 'TOTAL' &&
                              item.id !== 'HOLDING' &&
                              item.id !== 'SUB_HOLDING'
                            "
                            class="custom_checkbox_cash"
                          >
                            {{ item.name }}
                          </div>
                        </div>
                        <!-- <div class="d-flex flex-row-reverse align-items-center">
                          <div>
                            <input
                              class="form-check-input custom_checkbox_kwh"
                              type="checkbox"
                              disabled
                              v-model="isChecked"
                            />
                          </div>
                          <div class="custom_checkbox_texts">
                            Available Cash
                          </div>
                        </div>
                        <div class="d-flex flex-row-reverse align-items-center">
                          <div>
                            <input
                              class="form-check-input custom_checkbox_connect"
                              type="checkbox"
                              disabled
                              v-model="isChecked"
                            />
                          </div>
                          <div class="custom_checkbox_texts">
                            Restricted Cash
                          </div>
                        </div> -->
                        <div class="checkbox-solid-primary">
                          <!-- <label class="m-r-5 custom_checkbox_cash"
                            >Minimum Cash Balance</label
                          >
                          <span style="color: red; font-weight: bold"
                            >......</span
                          > -->
                          <div class="legend-item">
                            <span class="custom_checkbox_cash"
                              >Minimum Cash Balance</span
                            >
                            <div class="legend-symbol line-circles">
                              <div class="line"></div>
                              <div class="circle"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="justify-content: space-between; display: flex"
                ></div>
                <div class="thermal-mobile">
                  <apexchart
                    ref="chart"
                    width="100%"
                    type="line"
                    :options="optionsCashChart"
                    :series="cashChartData"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="profit-sidebar card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="../../assets/images/svg-icon/Money.svg"
                alt=""
              />
              <div class="text">
                <h5 class="title">Asset Management</h5>
                <!-- <span class="subtitle"
                  >Last Updated: {{ lastUpdateAsset }}</span
                > -->
              </div>
            </div>
            <div @click="more" class="cstm-drop card-header-right">
              <span class="text-detail"
                >MORE <i class="fa fa-angle-right"></i
              ></span>
            </div>
          </div>
          <!-- <div class="bg-label-third">
            <div class="header-top">
              <h6 class="m-0 text-alert">
                <img src="../../assets/images/svg-icon/alert-gray.svg" />
                No insights for now
              </h6>
              <div class="card-header-right-icon">
                <DropDown1 />
              </div>
            </div>
          </div> -->
          <div class="card-body profit-sidebar">
            <div
              v-for="(item, id) in dataAssetManagement"
              :key="id"
              style="padding: 7%"
              class="card card_white m-t-25 m-b-25"
            >
              <div class="sub_title_2">
                {{ item.metricName }} {{ getSymbol(item.currency) }}
              </div>
              <div
                style="justify-content: space-between"
                class="d-flex align-items-center"
              >
                <div class="m-b-20 m-t-20 data_text">
                  {{ convertCurrency(item.value) }} {{ item.unit }}
                </div>
                <div style="flex: 1; text-align: right" class="d-flex ms-2">
                  <div
                    @mouseenter="showTooltipArc"
                    @mouseleave="hideTooltipArc"
                    class="d-inline-flex align-items-center me-2 tooltip-container"
                    :class="
                      item.achievementStatus === 'DOWN'
                        ? 'badge_red'
                        : 'badge_green'
                    "
                  >
                    <div v-if="visibleArc" class="tooltip-content">
                      <span>Achievement</span>
                    </div>
                    <IconSvg
                      :color="
                        item.achievementStatus === 'DOWN' ? 'red' : 'green'
                      "
                      :type="
                        item.achievementStatus === 'DOWN'
                          ? 'arrow_down'
                          : 'arrow_up'
                      "
                    />
                    <div
                      class="data_detil"
                      :style="
                        item.achievementStatus === 'DOWN'
                          ? 'color: red'
                          : 'color:green'
                      "
                    >
                      {{ item.achievement !== null ? item.achievement : "-" }}
                    </div>
                  </div>
                  <div
                    @mouseenter="showTooltip"
                    @mouseleave="hideTooltip"
                    class="d-inline-flex align-items-center me-2 tooltip-container"
                    :class="
                      item.trendStatus === 'DOWN' ? 'badge_red' : 'badge_green'
                    "
                  >
                    <div
                      style="left: 60px !important"
                      v-if="visible"
                      class="tooltip-content"
                    >
                      <span>Trend</span>
                    </div>
                    <IconSvg
                      :color="item.trendStatus === 'DOWN' ? 'red' : 'green'"
                      :type="
                        item.trendStatus === 'DOWN' ? 'chart_down' : 'chart_up'
                      "
                    />
                    <div
                      class="data_detil"
                      :style="
                        item.trendStatus === 'DOWN'
                          ? 'color: red'
                          : 'color:green'
                      "
                    >
                      {{ item.trend !== null ? item.trend : "-" }}
                    </div>
                  </div>
                </div>
                <div style="color: #7a7a7a; font-size: small">
                  {{ item.description }}
                </div>
              </div>
              <div class="d-inline-flex align-items-center me-2">
                <div style="color: #7a7a7a; font-size: small">
                  Period: {{ convertToMMMYYYY(item.month, item.year) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  zoomPlugin,
  Title,
  Tooltip,
  Filler
);
import moment from "moment";
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";

import FinanceService from "@/services/finance/finance";
import ReferenceService from "@/services/reference/reference";
import IconSvg from "@/components/IconSvg.vue";
import DropDown1 from "../../components/dropdown/DropDown1";
import { currencyFormatNumberComma } from "@/utils/helper";
import zoomPlugin from "chartjs-plugin-zoom";

const getRef = ReferenceService.build();
const getFinance = FinanceService.build();
export default {
  components: {
    IconSvg,
    DropDown1,
    Line,
  },
  data() {
    return {
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: window.devicePixelRatio / 0.5,
        tooltips: {
          enabled: true,
          mode: "nearest",
          intersect: false,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            position: "nearest",
            // yAlign: "bottom",
            external: (context) => {
              const tooltip = context.tooltip;
              // Adjust tooltip position based on zoom
              const zoomScale = window.devicePixelRatio / 0.5;
              tooltip.xAlign = "left";
              tooltip.yAlign = "top";
            },
            callbacks: {
              afterBody: function (context) {
                // Custom logic to correct positioning based on zoom
              },
            },
          },
          datalabels: {
            display: false,
          },
          // zoom: {
          //   zoom: {
          //     wheel: {
          //       enabled: true, // Enable zooming with the mouse wheel
          //     },
          //     pinch: {
          //       enabled: true, // Enable zooming with touch gestures
          //     },
          //     mode: "x", // Zoom on the x-axis
          //   },
          //   pan: {
          //     enabled: true, // Enable panning
          //     mode: "x", // Pan on the x-axis
          //   },
          // },
        },
        scales: {
          x: {
            display: false,
          },
          y: {
            display: false,
          },
        },
        elements: {
          line: {
            borderWidth: 1.5,
          },
        },
        interaction: {
          intersect: false,
        },
      },
      isYear: true,
      lastUpdateCash: "",
      lastUpdateAsset: "",
      updateProfit: "",
      selectedOption: null,
      options: [
        { id: 1, name: "Option 1" },
        { id: 2, name: "Option 2" },
        { id: 3, name: "Option 3" },
        // Add more options as needed
      ],
      instanceId: { label: "Konsolidasi", value: "consolidated" },
      instanceIdCash: { label: "Konsolidasi", value: "consolidated" },
      dataInstance: [],
      cashChartData: [],
      isChecked: true,
      isCheckedProfit: [],
      isCheckedCash: [],
      isCheckedTarif: true,
      isCheckedRevenue: true,
      isCheckedSubs: true,
      isCheckedConn: true,
      isCheckedKwh: true,
      isActiveMonth: false,
      isActiveCumulative: false,
      isActive: false,
      title: "Finance",
      dataAssetManagement: [],
      idSummary: "REVENUE",
      titleProfit: "",
      unitProfit: "",
      visible: false,
      visibleArc: false,
      visibleDesc: false,
      desc: [{ childMsg: "Foo" }, { childMsg: "Bar" }],
      optionsCashChart: {
        chart: {
          type: "line",
          height: 300,
          stacked: true,
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 8,
            left: 0,
            blur: 10,
            color: "#7064F5",
            opacity: 0.1,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 4, // Apply border-radius to bars
            borderRadiusWhenStacked: "all", // "all"/"last"
          },
        },
        grid: {
          show: true,
          borderColor: "var(--chart-border)",
        },
        // dataLabels: {
        //   enabled: true,
        //   enabledOnSeries: [0], // Enable for first series (bars)
        //   formatter: (val, opts) => {
        //     // Only show data label for the first data point
        //     const group = opts.w.globals.initialSeries;
        //     const minCash = group.find(
        //       (item) => item.name === "Min Cash Balance"
        //     );
        //     if (opts.dataPointIndex === 0) {
        //       return minCash.data[0];
        //     }
        //     return "";
        //   },
        //   style: {
        //     fontSize: "14px",
        //     fontWeight: "bold",
        //     colors: ["#FF6B6B"], // Red color to match the image
        //   },
        //   offsetY: -10,
        //   offsetX: -15,
        //   background: {
        //     enabled: false,
        //   },
        // },
        stroke: {
          width: 2,
          colors: ["#fff"],
          dashArray: [0, 0, 0],
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
        },
        colors: [],
        yaxis: {
          tickAmount: 3,
          labels: {
            show: true,
            style: {
              colors: ["#999999"],
              fontFamily: "Rubik, sans-serif",
            },
            formatter: function (val, seriesIndex, dataPointIndex) {
              return val.toLocaleString() + " Tn";
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        labels: [],
        xaxis: {
          show: true,
          tickPlacement: "on",
          trim: false,
          rotate: -90,
          hideOverlappingLabels: false,
          labels: {
            style: {
              fontSize: "10px",
              fontFamily: "Rubik, sans-serif",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val, seriesIndex, dataPointIndex) {
              return (
                val.toFixed(2) +
                " " +
                seriesIndex.w.globals.initialSeries[0].group
              );
            },
          },
        },
        responsive: [
          {
            breakpoint: 1795,
            options: {
              chart: {
                width: "100%",
                height: 320,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                height: 260,
                width: "100%",
              },
            },
          },
          {
            breakpoint: 1400,
            options: {
              chart: {
                height: 240,
                width: "100%",
              },
            },
          },
          {
            breakpoint: 767,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35px",
                },
              },
              yaxis: {
                labels: {
                  show: false,
                },
              },
            },
          },
          {
            breakpoint: 481,
            options: {
              chart: {
                height: 400,
                width: "100%",
              },
              xaxis: {
                labels: {
                  rotate: -30,
                },
              },
            },
          },
          {
            breakpoint: 420,
            options: {
              chart: {
                height: 400,
                width: 700,
              },
              xaxis: {
                labels: {
                  rotate: -30,
                },
              },
            },
          },
        ],
      },
      options3: {
        chart: {
          type: "line",
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        fill: {
          opacity: 1,
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
            horizontal: false,
            borderRadius: 4, // Apply border-radius to bars
            borderRadiusWhenStacked: "all", // "all"/"last"
          },
        },
        grid: {
          strokeDashArray: 0,
          show: true,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        stroke: {
          width: 2,
          colors: ["#fff"],
          curve: "straight",
          dashArray: [],
        },
        colors: [],
        yaxis: {
          opposite: false,
          tickAmount: 5,
          labels: {
            style: {
              colors: ["#999999"],
            },
            formatter: function (val, seriesIndex, dataPointIndex) {
              return val.toLocaleString() + " IDR Tn";
            },
          },
        },
        tooltip: {
          shared: true,
          enabled: true,
          inverseOrder: true,
          marker: {
            show: true,
          },
          y: {
            show: true,
            formatter: function (val, seriesIndex, dataPointInde) {
              return (
                val.toFixed(2) +
                " " +
                seriesIndex.w.globals.initialSeries[0].group
              );
            },
          },
        },
        xaxis: {
          categories: [],
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        responsive: [
          {
            breakpoint: 1795,
            options: {
              chart: {
                width: "100%",
                height: 600,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                height: 700,
                width: "100%",
              },
            },
          },
          {
            breakpoint: 1400,
            options: {
              chart: {
                height: 600,
                width: "100%",
              },
            },
          },
          {
            breakpoint: 767,
            options: {
              plotOptions: {
                bar: {},
              },
              yaxis: {
                labels: {
                  show: false,
                },
              },
            },
          },
          {
            breakpoint: 481,
            options: {
              chart: {
                height: 400,
                width: "100%",
              },
              xaxis: {
                labels: {
                  rotate: -30,
                },
              },
            },
          },
          {
            breakpoint: 420,
            options: {
              chart: {
                height: 400,
                width: 700,
              },
              xaxis: {
                labels: {
                  rotate: -30,
                },
              },
            },
          },
        ],
      },
      cashChart: [],
      series3: [],
      dataProfit: [],
      leftChart: [],
      options4: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        grid: {
          show: false,
        },
        fill: {
          type: "gradient", // Enable gradient fill
          gradient: {
            shade: "light",
            type: "vertical", // Vertical gradient
            shadeIntensity: 1,
            gradientToColors: undefined, // To colors for gradient
            inverseColors: false,
            opacityFrom: 1, // Starting opacity
            opacityTo: 1, // Ending opacity
            stops: [0, 50, 100], // Control where the gradient transitions occur
            colorStops: [
              {
                offset: 0,
                color: "#1B59F8", // Red for negative values
                opacity: 1,
              },
              {
                offset: 50,
                color: "#FF4560", // Green for positive values
                opacity: 1,
              },
            ],
          },
        },
        colors: [
          ({ value }) => (value >= 0 ? "#1B59F8" : "#FF4560"), // Dynamic color based on positive or negative values
        ],
        stroke: {
          width: 2,
          curve: "smooth",
        },
        labels: [],
        markers: {},
        xaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
            width: [2, 2, 2],
            dashArray: [0, 0, 0],
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          shared: true,
          hideEmptySeries: false,
          marker: {
            show: true,
          },
          x: {
            show: true,
            formatter: function (val) {
              return "M " + val;
            },
          },
          y: {
            show: true,
            formatter: function (val) {
              return val.toLocaleString() + " %";
            },
          },
        },
        responsive: [
          {
            breakpoint: 1980,
            options: {
              chart: {
                width: "50%",
                height: 100,
              },
            },
          },
          {
            breakpoint: 1795,
            options: {
              chart: {
                width: "50%",
                height: 100,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                width: "50%",
                height: 100,
              },
            },
          },
        ],
      },
      series4: [
        {
          name: "Sales",
          data: [0, 0, 463, 0, 145, 374, 4],
        },
      ],
      dataCheckbox: [],
      dataTemp: [],
      dataCheckboxCash: [],
      dataTempCash: [],
      isChart: false,
      isZoom: false,
      cardName: "",
    };
  },
  created() {
    this.getData();
    // if (window.innerWidth > 1500 && window.innerWidth < 1600) {
    //  this.isZoom = true;
    // }
    this.getDataCash();
    this.getProfitChart();
    this.getAssetManagement();
    this.getDataCashChart();
    this.getComboInstance();
  },
  watch: {
    isCheckedCash(x) {
      const filter = this.dataTempCash.filter((item) => x.includes(item.id));
      this.cashChartData = filter;
    },
    isCheckedProfit(x) {
      const filter = this.dataTemp.filter((item) => x.includes(item.id));

      // Recalculate total from checked items
      const totalItem = this.dataTemp.find(
        (item) => item.name && item.name.includes("Total")
      );
      if (totalItem) {
        const checkedItems = this.dataTemp.filter(
          (item) => x.includes(item.id) && item.type === "column"
        );

        if (checkedItems.length > 0) {
          const totalData = [];
          for (let i = 0; i < totalItem.data.length; i++) {
            let sum = 0;
            checkedItems.forEach((item) => {
              if (item.data && item.data[i] !== undefined) {
                sum += item.data[i];
              }
            });
            totalData.push(sum);
          }
          totalItem.data = totalData;
        }
      }

      this.series3 = filter;
    },
    instanceId() {
      this.instanceId = this.instanceId;
      setTimeout(() => {
        this.getData();
        this.getProfitChart();
      }, 100);
    },
    instanceIdCash() {
      this.instanceIdCash = this.instanceIdCash;
      this.getDataCash();
      this.getDataCashChart();
    },
    shouldTriggerFunction3(newVal) {
      if (newVal) {
        this.takeScreenshot(); // Call your function here
        this.$store.dispatch("resetTriggerFunction"); // Reset trigger after calling function
      }
    },
  },
  computed: {
    ...mapGetters(["shouldTriggerFunction3"]),
  },
  mounted() {
    this.$store.commit("updateJudulHalaman", "");
  },
  methods: {
    formatingData(data) {
      return {
        labels: [
          "M 1",
          "M 2",
          "M 3",
          "M 4",
          "M 5",
          "M 6",
          "M 7",
          "M 8",
          "M 9",
          "M 10",
          "M 11",
          "M 12",
        ],
        datasets: [
          {
            label: "Trend",
            data: data[0].data, // Data for the mini chart
            fill: true, // Enable gradient fill
            segment: {
              borderColor: (ctx) => {
                // Custom color logic for each segment
                const { p0, p1 } = ctx;
                return p1.parsed.y >= 0 ? "#008FFB" : "#FF4560"; // Blue for positive, red for negative
              },
            },
            pointBackgroundColor: (ctx) => {
              // Dynamic color for points
              const { parsed } = ctx;
              return parsed.y >= 0 ? "#008FFB" : "#FF4560"; // Blue for positive, red for negative
            },
            backgroundColor: (ctx) => {
              const chart = ctx.chart;
              const { ctx: canvas } = chart;
              const gradient = canvas.createLinearGradient(
                0,
                0,
                0,
                chart.height
              );
              gradient.addColorStop(0, "rgba(0, 143, 251, 0.2)"); // Light blue for positive
              gradient.addColorStop(1, "rgba(255, 69, 96, 0.1)"); // Light red for negative
              return gradient;
            },
            pointRadius: 0, // No points
            tension: 0.4, // Smooth line
          },
        ],
      };
    },
    convertToDDMMMYYYY(date, month, year) {
      if (month !== null) {
        return moment(`${date}, ${month}, ${year}`, "DD, M, YYYY").format(
          "DD MMM YYYY"
        );
      } else {
        return "-";
      }
    },
    convertToMMMYYYY(month, year) {
      if (month !== null) {
        return moment(`${month}, ${year}`, "M, YYYY").format("MMM, YYYY");
      } else {
        return "-";
      }
    },
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    showTooltipArc() {
      this.visibleArc = true;
    },
    hideTooltipArc() {
      this.visibleArc = false;
    },
    showTooltipDesc() {
      this.visibleDesc = true;
    },
    hideTooltipDesc() {
      this.visibleDesc = false;
    },

    async takeScreenshot() {
      const targetElement = this.$refs.screenshotTarget;

      try {
        const canvas = await html2canvas(targetElement);
        this.downloadCanvasImage(canvas);
      } catch (error) {
        console.error("Error while taking screenshot:", error);
      }
    },
    downloadCanvasImage(canvas) {
      // Convert canvas to image data URL
      const imgData = canvas.toDataURL("image/png");

      // Create temporary link element
      const downloadLink = document.createElement("a");
      downloadLink.href = imgData;
      downloadLink.download = `Finance_${moment(new Date()).format(
        "DD-MM-YYYY HH:mm"
      )}.png`;
      document.body.appendChild(downloadLink);

      // Trigger download
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
    },
    getSymbol(x) {
      return x !== null ? `(${x})` : "";
    },
    formatCurrency(value) {
      const options = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };

      // Format the number using Intl.NumberFormat
      const formattedValue = new Intl.NumberFormat("en-US", options).format(
        value
      );

      // Add the minus sign if the value is negative
      return value < 0 ? formattedValue.replace(/^\$/, "-$&") : formattedValue;
    },
    convertCurrency(x) {
      const num = Number(x);
      if (isNaN(num)) return x;
      const formatted = num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatted;
    },
    async getComboInstance() {
      const res = await getRef.getRefHolding();
      const data = res.data.data;
      data.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0;
      });
      this.dataInstance = data;
    },
    detailItem(x) {
      this.leftChart.forEach((e) => {
        if (e.metricId === x.metricId) {
          e.clicked = true;
          this.cardName = x.metricName;
          this.idSummary = x.metricId;
          this.getProfitChart();
        } else {
          e.clicked = false;
        }
      });
    },
    async getDataCashChart() {
      const param = {
        instance: this.instanceIdCash.value,
      };
      const res = await getFinance.getDataCashChart(param);
      const data = res.data.data.values;
      // let color = ["#66e0ff", "#c2d6d6"];8099D9 C892F8
      let color = ["#C892F8", "#8099D9"];
      data.sort((a, b) => {
        if (a.id.toLowerCase() < b.id.toLowerCase()) return -1;
        if (a.id.toLowerCase() > b.id.toLowerCase()) return 1;
        return 0;
      });
      const result = data.map((el, index) => ({
        ...el,
        color: color[index],
      }));
      const resultArray = [];

      const length = result[0].data.length;
      for (let i = 0; i < length; i++) {
        resultArray.push(res.data.data.minimunCashBalance);
      }
      let datas = [];
      if (this.instanceIdCash.value === "consolidated") {
        this.lastUpdateCash = res.data.lastUpdate;
        datas = [
          {
            id: result.find((obj) => obj.id === "AVAILABLE_CASH").id,
            color: "#C892F8",
            name: result.find((obj) => obj.id === "AVAILABLE_CASH").name,
            type: "column",
            data: result.find((obj) => obj.id === "AVAILABLE_CASH").data,
            group: result.find((obj) => obj.id === "AVAILABLE_CASH").unit,
          },
          {
            id: result.find((obj) => obj.id === "HOLDING")?.id || "",
            color: "#80FF0000",
            name: result.find((obj) => obj.id === "HOLDING")?.name || "",
            type: "",
            data: result.find((obj) => obj.id === "HOLDING")?.data || [],
            group: result.find((obj) => obj.id === "HOLDING")?.unit || "",
          },
          {
            id: result.find((obj) => obj.id === "SUB_HOLDING")?.id || "",
            color: "#80FF0000",
            name: result.find((obj) => obj.id === "SUB_HOLDING")?.name || "",
            type: "",
            data: result.find((obj) => obj.id === "SUB_HOLDING")?.data || [],
            group: result.find((obj) => obj.id === "SUB_HOLDING")?.unit || "",
          },
          {
            id: result.find((obj) => obj.id === "RESTRICTED_CASH").id,
            color: "#8099D9",
            name: result.find((obj) => obj.id === "RESTRICTED_CASH").name,
            type: "column",
            data: result.find((obj) => obj.id === "RESTRICTED_CASH").data,
            group: result.find((obj) => obj.id === "RESTRICTED_CASH").unit,
          },
          {
            id: result.find((obj) => obj.id === "HOLDING_RESTRICTED").id,
            color: "#80FF0000",
            name: result.find((obj) => obj.id === "HOLDING_RESTRICTED").name,
            type: "column",
            data: result.find((obj) => obj.id === "HOLDING_RESTRICTED").data,
            group: result.find((obj) => obj.id === "HOLDING_RESTRICTED").unit,
          },
          {
            id: result.find((obj) => obj.id === "SUB_HOLDING_RESTRICTED").id,
            color: "#80FF0000",
            name: result.find((obj) => obj.id === "SUB_HOLDING_RESTRICTED")
              .name,
            type: "column",
            data: result.find((obj) => obj.id === "SUB_HOLDING_RESTRICTED")
              .data,
            group: result.find((obj) => obj.id === "SUB_HOLDING_RESTRICTED")
              .unit,
          },
          {
            color: "#ff5151",
            name: "Min Cash Balance",
            type: "line",
            data: result[0].target,
          },
          {
            id: result.find((obj) => obj.id === "TOTAL")?.id || "",
            color: "#80FF0000",
            name: result.find((obj) => obj.id === "TOTAL")?.name || "",
            type: "",
            data: result.find((obj) => obj.id === "TOTAL")?.data || [],
            group: result.find((obj) => obj.id === "TOTAL")?.unit || "",
          },
        ];
      } else {
        datas = [
          {
            id: result.find((obj) => obj.id === "AVAILABLE_CASH").id,
            color: "#C892F8",
            name: result.find((obj) => obj.id === "AVAILABLE_CASH").name,
            type: "column",
            data: result.find((obj) => obj.id === "AVAILABLE_CASH").data,
            group: result.find((obj) => obj.id === "AVAILABLE_CASH").unit,
          },
          {
            id: result.find((obj) => obj.id === "RESTRICTED_CASH").id,
            color: "#8099D9",
            name: result.find((obj) => obj.id === "RESTRICTED_CASH").name,
            type: "column",
            data: result.find((obj) => obj.id === "RESTRICTED_CASH").data,
            group: result.find((obj) => obj.id === "RESTRICTED_CASH").unit,
          },
          {
            color: "#ff5151",
            name: "Min Cash Balance",
            type: "line",
            data: result[0].target,
          },
          {
            id: result.find((obj) => obj.id === "TOTAL")?.id || "",
            color: "#80FF0000",
            name: result.find((obj) => obj.id === "TOTAL")?.name || "",
            type: "",
            data: result.find((obj) => obj.id === "TOTAL")?.data || [],
            group: result.find((obj) => obj.id === "TOTAL")?.unit || "",
          },
        ];
        this.lastUpdateCash =
          res.data.lastUpdate + " - " + this.instanceIdCash.label;
      }
      const item = datas.map((obj) => obj.id);
      this.isCheckedCash = item;
      this.dataCheckboxCash = datas;
      this.dataTempCash = datas;
      this.cashChartData = datas;

      this.optionsCashChart = {
        xaxis: { categories: result[0].periode.map(this.changeDateFormat) },
        annotations: {
          yaxis: [
            {
              y: result[0].target[0],
              borderColor: "#FF4560",
              label: {
                borderColor: "#FF4560",
                style: {
                  fontSize: "14px",
                  color: "#fff",
                  background: "#FF4560",
                },
                text: result[0].target[0] + " Tn",
                position: "right", // This is the key property to move the label to the end
              },
            },
          ],
        },
      };
      // this.dataAssetManagement = data;
      this.$refs.chart;
    },
    changeDateFormat(dateStr) {
      const [month, day, year] = dateStr.split("/");
      return moment(month).format("DD MMM YYYY");
    },
    async getAssetManagement() {
      const res = await getFinance.getAssetManagement();
      const data = res.data.data;
      this.lastUpdateAsset = res.data.lastUpdate;
      this.dataAssetManagement = data;
    },
    async getProfitChart() {
      this.dataTemp = [];
      this.series3 = [];
      const id = this.idSummary;
      const param = {
        instance: this.instanceId.value,
        period: this.isActiveMonth ? "annually" : "monthly",
        type: this.isActiveCumulative ? "cumulative" : "noncumulative",
      };
      const res = await getFinance.getDataProfitChart(param, id);
      const data = res.data;
      const value = data.data.values;
      const length = value[0].data.length;
      const resultArray = [];
      for (let i = 0; i < length; i++) {
        resultArray.push(data.data.targets);
      }
      const target = {
        color: "#ff5151",
        name: "Target",
        type: "line",
        data: data.data.targets,
        group: " ",
      };
      // Calculate total from checked items
      const calculateTotalFromChecked = () => {
        const checkedItems = value.filter((item) =>
          this.isCheckedProfit.includes(item.id)
        );
        if (checkedItems.length === 0) return data.data.total;

        const totalData = [];
        for (let i = 0; i < data.data.total.length; i++) {
          let sum = 0;
          checkedItems.forEach((item) => {
            if (item.data && item.data[i] !== undefined) {
              sum += item.data[i];
            }
          });
          totalData.push(sum);
        }
        return totalData;
      };

      const total = {
        color: "#80FF0000",
        name: "Total " + this.cardName,
        type: "",
        data: calculateTotalFromChecked(),
        group: " ",
      };
      const newArrayOfObj = value.map(({ unit: group, ...rest }) => ({
        group,
        type: "column",
        ...rest,
      }));
      // let dataArray = [
      //   "#C892F8",
      //   "#9780D9",
      //   "#9A9BF0",
      //   "#8099D9",
      //   "#92CAF8",
      //   "#C892F8",
      //   "#9780D9",
      //   "#9A9BF0",
      //   "#8099D9",
      //   "#92CAF8",
      // ];
      // const result = value.map((el, index) => ({
      //   ...el,
      //   color: dataArray[index],
      // }));
      this.dataCheckbox = value;
      this.titleProfit = data.data.name;
      this.unitProfit = data.data.currency;
      const datas = newArrayOfObj.reverse();
      datas.push(total);
      datas.push(target);
      this.dataTemp = datas;
      const label = value.map((obj) => obj.labels);
      // this.options3.labels = label[0];
      const item = newArrayOfObj.map((obj) => obj.id);
      this.isCheckedProfit = item;
      this.series3 = data;
      this.options3 = {
        xaxis: { categories: label[0] },
        stroke: { dashArray: this.createArray(newArrayOfObj.length, 0) },
      };
      // this.options3 = { stroke: { dashArray: [6] } };
    },
    createArray(length, lastValue = 1) {
      // Initialize the array with zeros (or any default value you prefer)
      const arr = new Array(length).fill(0);

      // Set the last index to 1 (or any value you specify)
      arr[length - 1] = lastValue;

      return arr;
    },
    setNewKey(array, keyName) {
      array.forEach((obj) => {
        obj[keyName] = obj.name; // Extracting 'name' value and setting it to the new key
      });
    },
    async getDataCash() {
      const param = {
        instanceId: this.instanceIdCash.value,
      };
      const res = await getFinance.getDataCash(param);
      this.lastUpdateCash = res.data.lastUpdate;
      const data = res.data;
      this.dataProfit = data.data;
    },
    async getData() {
      const param = {
        instanceId: this.instanceId.value,
      };
      const res = await getFinance.getDataProfit(param);
      const msg = res.data.lastUpdate;
      this.updateProfit = msg;
      const data = res.data.data.data;
      const val = data.map((obj) => obj.values);
      let dummy = [];
      for (let i = 0; i < val.length; i++) {
        let data = {
          name: "Trend",
          data: val[i],
        };
        dummy.push(data);
      }

      data.forEach((obj, index) => {
        obj["datas"] = [dummy[index]];
      });
      this.leftChart = data;
      this.detailItem(data[0]);
      this.$refs.realtimeChart;
    },
    detailCash() {
      // this.$router.push({ name: "detail-cash" });
      this.$router.push({ name: "Cash Management" });
    },
    more() {
      // this.$router.push({ name: "detail-assets" });
      this.$router.push({ name: "Asset Management" });
    },
    profit() {
      // this.$router.push({ name: "detail-profit" });
      this.$router.push({ name: "Profit & Loss" });
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
      this.isYear = !this.isYear;
      this.getProfitChart();
    },
    cumulative() {
      this.isActiveCumulative = !this.isActiveCumulative;
      this.getProfitChart();
    },
    toggleSwitch() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style scoped>
.btn-small {
  padding: 0.4rem 1rem;
  font-size: 11px;
}
.border-period-left {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.border-period-right {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
#logo-holder {
  position: relative;
}
#logo-holder .image,
#logo-holder .texts {
  transition: opacity 0.5s ease-in-out;
}
#logo-holder .image1,
#logo-holder .text1 {
  transition: opacity 0.5s ease-in-out;
}
#logo-holder .texts {
  position: absolute;
  font-size: 12px;
  top: 10px;
  left: 30px;
  opacity: 0;
}
#logo-holder .text1 {
  position: absolute;
  font-size: 12px;
  top: 10px;
  left: 90px;
  opacity: 0;
}

#logo-holder:hover .image {
  opacity: 1;
  margin-left: 60px;
}
#logo-holder:hover .image1 {
  opacity: 1;
  margin-left: 30px;
}
#logo-holder:hover .texts {
  opacity: 1;
  background-color: green;
  color: white;
  margin-right: 10px;
}
#logo-holder:hover .text1 {
  opacity: 1;
  background-color: green;
  color: white;
  margin-left: 7px;
}
.font-gray {
  color: #4e4e4e !important;
}
.title-left {
  white-space: normal;
  width: 155px;
}
.left-card {
  border: 1px solid #e5e7ed;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 10px;
}
.title-chart-right {
  color: #4e4e4e;
  font-weight: bold;
}
.header-right-chart {
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
}
.custom-dropdown {
  background-color: #e6e6e6; /* Set the background color to gray */
  padding: 8px; /* Add padding for better appearance */
  border: none; /* Remove default border */
  border-radius: 4px; /* Add border radius for rounded corners */
  outline: none; /* Remove focus outline */
  /* Add any additional styles here */
}
/* .checkbox1 {
  background-color: #92caf8;
} */
.checkbox1 {
  display: none; /* Hide the default checkbox */
}

/* Style the label associated with the custom checkbox */
.checkbox1 + label {
  position: relative;
  padding-left: 25px; /* Adjust the padding to accommodate the custom checkbox */
  cursor: pointer;
}

/* Style the custom checkbox */
.checkbox1 + label::before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #e0e0e0; /* Background color of the custom checkbox */
  border: 1px solid #ccc; /* Border color */
  border-radius: 4px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Change background color when checked */
.checkbox1:checked + label::before {
  background-color: #92caf8; /* Background color when checked */
}
.container-cash-cart {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}

/* .item {
  width: 48%; 
} */
.text-detail:hover {
  color: #00a3e9;
}

.text-detail:hover i {
  color: #00a3e9 !important;
}
.color-active {
  color: #fff !important;
}
.btn-disable {
  color: #999999;
  background-color: #e9e9e9;
}
.profit-card {
  /* justify-content: center; */
  padding: 2%;
}
.page-wrapper .page-body-wrapper .page-title .row {
  align-items: normal !important;
}
.clicked {
  border-color: #00a3e9;
  background-color: #ecf9ff;
}
/* ::v-deep .multiselect__option--highlight {
  display: none;
} */
::v-deep .multiselect__single {
  font-size: 13px !important;
  background-color: #e6e6e6 !important;
}
::v-deep .multiselect__tags {
  background-color: #e6e6e6 !important;
}
::v-deep .multiselect__input {
  background-color: #e6e6e6 !important;
}
::v-deep .multiselect {
  border-radius: 0.375rem !important;
}
::v-deep .multiselect__content-wrapper::-webkit-scrollbar {
  display: none; /* Hide scrollbar in Webkit-based browsers */
}
::v-deep .multiselect__option {
  font-size: 13px !important;
  white-space: pre-wrap !important;
}
::v-deep .multiselect__option--highlight {
  background: #ecf9ff !important ;
  color: black;
}
::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background: #ecf9ff;
  color: black;
}
.vue-multiselect:hover .vue-multiselect__control {
  border: 2px solid #007bff; /* Blue border on hover */
}

/* Hover effect on each dropdown option */
.vue-multiselect__option:hover {
  background-color: #f0f0f0; /* Light gray background on hover */
  border: 1px solid #007bff; /* Border on hover */
}

/* Hover effect on the selected tags */
.vue-multiselect__tag:hover {
  border: 1px solid #007bff; /* Blue border on hover */
  background-color: #f0f0f0; /* Light gray background on hover */
}
.multiselect:hover {
  border: 1px solid #00a3e9 !important;
}
.data_text_cash {
  font-size: 22px;
  font-weight: bold;
  line-height: 33px;
}
@media screen and (min-width: 1200px) and (max-width: 1400px) {
  .margin-card-cash {
    margin-top: -15px;
  }
  .data_text_cash {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
}
@media screen and (min-width: 1500px) and (max-width: 1600px) {
  .margin-card-cash {
    margin-top: -20px;
  }
  .data_text_cash {
    font-size: 28px;
    font-weight: bold;
    line-height: 35px;
  }
}
.legend-items {
  display: flex;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  /* margin-right: 15px; */
}

/* .legend-symbol {
  margin-right: 5px;
} */

.line-circle {
  position: relative;
  width: 60px;
  height: 20px;
}

.line-circles {
  position: relative;
  width: 15px;
  height: 20px;
}

.line {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #ff0000;
}

.version-desc {
  color: #7a7a7a;
  font-size: small;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>
